function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("metadata", null, "Created by potrace 1.10, written by Peter Selinger 2001-2011");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.000000,65.000000) scale(0.100000,-0.100000)",
  fill: "#737373",
  stroke: "none"
}, React.createElement("path", {
  d: "M305 640 c-166 -13 -250 -83 -290 -237 -34 -134 33 -296 147 -354 21\n-11 75 -24 120 -31 109 -14 346 -5 416 17 70 21 124 72 164 152 27 54 31 75\n31 136 -1 132 -66 243 -171 289 -73 33 -232 43 -417 28z m155 -530 c0 -22 -4\n-40 -10 -40 -5 0 -10 18 -10 40 0 22 5 40 10 40 6 0 10 -18 10 -40z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.0,
    width: "90.000000pt",
    height: "65.000000pt",
    viewBox: "0 0 90.000000 65.000000",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/powerdot.7f1180ad.svg";
export { SvgComponent as ReactComponent };